module.exports = __webpack_public_path__ + "static/media/after-Introduksjon-sprakforstael.0867e3b9.mp3";